export const ALL_NEEDS_REQUEST = 'ALL_NEEDS_REQUEST';
export const ALL_NEEDS_SUCCESS = 'ALL_NEEDS_SUCCESS';
export const ALL_NEEDS_FAIL = 'ALL_NEEDS_FAIL';
export const ALL_NEEDS_RESET = 'ALL_NEEDS_RESET';

export const ALL_REPORT_NEEDS_REQUEST = 'ALL_REPORT_NEEDS_REQUEST';
export const ALL_REPORT_NEEDS_SUCCESS = 'ALL_REPORT_NEEDS_SUCCESS';
export const ALL_REPORT_NEEDS_FAIL = 'ALL_REPORT_NEEDS_FAIL';
export const ALL_REPORT_NEEDS_RESET = 'ALL_REPORT_NEEDS_RESET';

export const CHILD_EXAMPLE_NEEDS_REQUEST = 'CHILD_EXAMPLE_NEEDS_REQUEST';
export const CHILD_EXAMPLE_NEEDS_SUCCESS = 'CHILD_EXAMPLE_NEEDS_SUCCESS';
export const CHILD_EXAMPLE_NEEDS_FAIL = 'CHILD_EXAMPLE_NEEDS_FAIL';
export const CHILD_EXAMPLE_NEEDS_RESET = 'CHILD_EXAMPLE_NEEDS_RESET';

export const CHILD_NEEDS_REQUEST = 'CHILD_NEEDS_REQUEST';
export const CHILD_NEEDS_SUCCESS = 'CHILD_NEEDS_SUCCESS';
export const CHILD_NEEDS_FAIL = 'CHILD_NEEDS_FAIL';
export const CHILD_NEEDS_RESET = 'CHILD_NEEDS_RESET';

export const UNCONFIRMED_NEEDS_REQUEST = 'UNCONFIRMED_NEEDS_REQUEST';
export const UNCONFIRMED_NEEDS_SUCCESS = 'UNCONFIRMED_NEEDS_SUCCESS';
export const UNCONFIRMED_NEEDS_FAIL = 'UNCONFIRMED_NEEDS_FAIL';
export const UNCONFIRMED_NEEDS_RESET = 'UNCONFIRMED_NEEDS_RESET';

export const DUPLICATES_NEEDS_REQUEST = 'DUPLICATES_NEEDS_REQUEST';
export const DUPLICATES_NEEDS_SUCCESS = 'DUPLICATES_NEEDS_SUCCESS';
export const DUPLICATES_NEEDS_FAIL = 'DUPLICATES_NEEDS_FAIL';
export const DUPLICATES_NEEDS_RESET = 'DUPLICATES_NEEDS_RESET';

export const PREPARE_CONFIRM_NEEDS_REQUEST = 'PREPARE_CONFIRM_NEEDS_REQUEST';
export const PREPARE_CONFIRM_NEEDS_SUCCESS = 'PREPARE_CONFIRM_NEEDS_SUCCESS';
export const PREPARE_CONFIRM_NEEDS_FAIL = 'PREPARE_CONFIRM_NEEDS_FAIL';
export const PREPARE_CONFIRM_NEEDS_RESET = 'PREPARE_CONFIRM_NEEDS_RESET';

export const CHILD_ONE_NEED_REQUEST = 'CHILD_ONE_NEED_REQUEST';
export const CHILD_ONE_NEED_SUCCESS = 'CHILD_ONE_NEED_SUCCESS';
export const CHILD_ONE_NEED_FAIL = 'CHILD_ONE_NEED_FAIL';
export const CHILD_ONE_NEED_RESET = 'CHILD_ONE_NEED_RESET';

export const SW_NEED_LIST_REQUEST = 'SW_NEED_LIST_REQUEST';
export const SW_NEED_LIST_SUCCESS = 'SW_NEED_LIST_SUCCESS';
export const SW_NEED_LIST_FAIL = 'SW_NEED_LIST_FAIL';
export const SW_NEED_LIST_RESET = 'SW_NEED_LIST_RESET';

export const MASS_NEED_CONFIRM_REQUEST = 'MASS_NEED_CONFIRM_REQUEST';
export const MASS_NEED_CONFIRM_SUCCESS = 'MASS_NEED_CONFIRM_SUCCESS';
export const MASS_NEED_CONFIRM_FAIL = 'MASS_NEED_CONFIRM_FAIL';
export const MASS_NEED_CONFIRM_RESET = 'MASS_NEED_CONFIRM_RESET';

export const UPDATE_NEED_CONFIRM_REQUEST = 'UPDATE_NEED_CONFIRM_REQUEST';
export const UPDATE_NEED_CONFIRM_SUCCESS = 'UPDATE_NEED_CONFIRM_SUCCESS';
export const UPDATE_NEED_CONFIRM_FAIL = 'UPDATE_NEED_CONFIRM_FAIL';
export const UPDATE_NEED_CONFIRM_RESET = 'UPDATE_NEED_CONFIRM_RESET';

export const UPDATE_ONE_NEED_REQUEST = 'UPDATE_ONE_NEED_REQUEST';
export const UPDATE_ONE_NEED_SUCCESS = 'UPDATE_ONE_NEED_SUCCESS';
export const UPDATE_ONE_NEED_FAIL = 'UPDATE_ONE_NEED_FAIL';
export const UPDATE_ONE_NEED_RESET = 'UPDATE_ONE_NEED_RESET';

export const UPDATE_NEED_STATUS_REQUEST = 'UPDATE_NEED_STATUS_REQUEST';
export const UPDATE_NEED_STATUS_SUCCESS = 'UPDATE_NEED_STATUS_SUCCESS';
export const UPDATE_NEED_STATUS_FAIL = 'UPDATE_NEED_STATUS_FAIL';
export const UPDATE_NEED_STATUS_RESET = 'UPDATE_NEED_STATUS_RESET';

export const ADD_ONE_NEED_REQUEST = 'ADD_ONE_NEED_REQUEST';
export const ADD_ONE_NEED_SUCCESS = 'ADD_ONE_NEED_SUCCESS';
export const ADD_ONE_NEED_FAIL = 'ADD_ONE_NEED_FAIL';
export const ADD_ONE_NEED_RESET = 'ADD_ONE_NEED_RESET';

export const DELETE_NEED_REQUEST = 'DELETE_NEED_REQUEST';
export const DELETE_NEED_SUCCESS = 'DELETE_NEED_SUCCESS';
export const DELETE_NEED_FAIL = 'DELETE_NEED_FAIL';

export const DELETE_CANDIDATES_REQUEST = 'DELETE_CANDIDATES_REQUEST';
export const DELETE_CANDIDATES_SUCCESS = 'DELETE_CANDIDATES_SUCCESS';
export const DELETE_CANDIDATES_FAIL = 'DELETE_CANDIDATES_FAIL';

export const GET_CANDIDATES_REQUEST = 'GET_CANDIDATES_REQUEST';
export const GET_CANDIDATES_SUCCESS = 'GET_CANDIDATES_SUCCESS';
export const GET_CANDIDATES_FAIL = 'GET_CANDIDATES_FAIL';

export const DELETE_OLD_NEEDS_REQUEST = 'DELETE_OLD_NEEDS_REQUEST';
export const DELETE_OLD_NEEDS_SUCCESS = 'DELETE_OLD_NEEDS_SUCCESS';
export const DELETE_OLD_NEEDS_FAIL = 'DELETE_OLD_NEEDS_FAIL';

export const UPDATE_ARRIVALS_REQUEST = 'UPDATE_ARRIVALS_REQUEST';
export const UPDATE_ARRIVALS_SUCCESS = 'UPDATE_ARRIVALS_SUCCESS';
export const UPDATE_ARRIVALS_FAIL = 'UPDATE_ARRIVALS_FAIL';